module.exports = __webpack_public_path__ + "img/input0.01f3f6cb.png";